export interface RuntimeConfig {
  region: string;
  userPoolId: string;
  userPoolClientId: string;
  apiBaseUrl: string;
  stage: string;
  localMode?: boolean;
}

let configPromise: Promise<RuntimeConfig> | undefined;

function isLocalHost(): boolean {
  return ['localhost', '127.0.0.1'].includes(window.location.hostname);
}

export function getRuntimeConfig(): Promise<RuntimeConfig> {
  if (configPromise) return configPromise;
  configPromise = fetch('/config.json', { cache: 'no-store' })
    .then(async (response) => {
      if (!response.ok) throw new Error(`config ${response.status}`);
      return await response.json() as RuntimeConfig;
    })
    .catch((error) => {
      if (import.meta.env.DEV && isLocalHost()) {
        return { region: __AWS_REGION__, userPoolId: '', userPoolClientId: '', apiBaseUrl: '', stage: 'local', localMode: true };
      }
      configPromise = undefined;
      throw new Error(`A configuração segura do KemiControl não está disponível. ${error instanceof Error ? error.message : ''}`);
    });
  return configPromise;
}
